export default "__VITE_ASSET__PAqZtfHN__"